import React, { useEffect, useState } from "react";
import { Check } from "react-feather";
import { ReactComponent as SEARCHICON } from "../../../assets/icons/search.svg";
import { languages } from "../../../Data/languages";

const SingleLanguageFilter = ({
  setShowModal,
  setSelectedLanguageFilter,
  selectedLanguageFilter,
}) => {
  const [filters, setFilters] = useState(selectedLanguageFilter);
  const [searchClient, setSearchClient] = useState("");

  // ✅ Close the modal if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".accountDetailsFilterPopup")) {
        setShowModal("");
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setShowModal]);

  const handleCheck = (language) => {
    if (filters.includes(language.value)) {
      setFilters((f) => f.filter((f) => f !== language.value));
    } else {
      setFilters((f) => [...f, language.value]);
    }
  };

  const handleApply = (filters) => {
    setSelectedLanguageFilter(filters);
    setShowModal("");
  };

  const handleClear = () => {
    setFilters([]);
    setSelectedLanguageFilter([]);
    setShowModal("");
  };

  return (
    <div className="accountDetailsFilterPopup">
      <div className="accountLanguageFilterSearch">
        <input
          className="accountLanguageFilterSearchInput"
          placeholder="Search by languages"
          vlaue={searchClient}
          autoFocus
          onChange={(e) => setSearchClient(e.target.value)}
        />
        <SEARCHICON className="accountLanguageFilterSearchIcon" />
      </div>

      <div className="accountDeatilsFilterItems">
        {languages
          .filter((el) => {
            return (
              el.value &&
              (searchClient?.trim()
                ? el.value.toLowerCase().includes(searchClient.toLowerCase())
                : true)
            );
          })
          .map((language, i) => (
            <div key={language.id} className="hardCopyCheckboxLine">
              <div
                className={`${
                  filters.includes(language.value) ? "hardCopyChecked" : ""
                } hardCopyCheckbox`}
              >
                <Check
                  className="hardCopyCheck"
                  onClick={() => {
                    handleCheck(language);
                  }}
                  style={{ opacity: filters.includes(language.value) ? 1 : 0 }}
                />
              </div>
              <p
                className="hardCopyCheckboxText"
                onClick={() => {
                  handleCheck(language);
                }}
              >
                {language.label}
              </p>
            </div>
          ))}
      </div>

      <div className="accountDetailsFilterPopupBtns">
        <button
          className="accountOrderBtn accountClearBtn"
          onClick={() => {
            handleClear();
          }}
        >
          Clear
        </button>
        <button
          disabled={filters.length === 0}
          className="accountOrderBtn"
          onClick={() => {
            handleApply(filters);
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default SingleLanguageFilter;
